import { render, staticRenderFns } from "./questionTag.vue?vue&type=template&id=7038225c&scoped=true"
import script from "./questionTag.vue?vue&type=script&lang=js"
export * from "./questionTag.vue?vue&type=script&lang=js"
import style0 from "./questionTag.vue?vue&type=style&index=0&id=7038225c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038225c",
  null
  
)

export default component.exports